import React from 'react'
import { useHistory } from 'react-router-dom'
import { get as _get } from 'lodash'
import { Helmet } from 'react-helmet'
import { Button } from '../ui/button'
import useAuth from '../../utilities/hooks/useAuth'
import { openCrispChat } from '../../utilities/crisp'

function SkaterFallingIllustration() {
  return (
    <svg viewBox="0 0 400 300" className="w-full max-w-md mx-auto" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="200" cy="100" r="30" fill="#a78bfa" opacity="0.3" />
      <circle cx="200" cy="100" r="20" fill="#8b5cf6" />

      <ellipse cx="190" cy="95" rx="5" ry="7" fill="#1f2937" />
      <ellipse cx="210" cy="95" rx="5" ry="7" fill="#1f2937" />
      <path d="M 190 110 Q 200 115 210 110" stroke="#1f2937" strokeWidth="2" fill="none" />

      <rect x="175" y="130" width="50" height="60" rx="25" fill="#8b5cf6" />

      <path d="M 180 140 L 150 180" stroke="#8b5cf6" strokeWidth="12" strokeLinecap="round" />
      <path d="M 220 140 L 250 170" stroke="#8b5cf6" strokeWidth="12" strokeLinecap="round" />

      <path d="M 185 185 L 170 230" stroke="#8b5cf6" strokeWidth="12" strokeLinecap="round" />
      <path d="M 215 185 L 230 235" stroke="#8b5cf6" strokeWidth="12" strokeLinecap="round" />

      <ellipse cx="168" cy="235" rx="20" ry="8" fill="#6366f1" />
      <rect x="158" y="235" width="20" height="8" fill="#4f46e5" />

      <ellipse cx="232" cy="240" rx="20" ry="8" fill="#6366f1" />
      <rect x="222" y="240" width="20" height="8" fill="#4f46e5" />

      <path d="M 140 160 Q 120 150 110 170" stroke="#e0e7ff" strokeWidth="3" strokeLinecap="round" opacity="0.6" />
      <path d="M 260 180 Q 280 170 290 190" stroke="#e0e7ff" strokeWidth="3" strokeLinecap="round" opacity="0.6" />
      <circle cx="100" cy="180" r="4" fill="#c4b5fd" opacity="0.5" />
      <circle cx="300" cy="200" r="4" fill="#c4b5fd" opacity="0.5" />
      <circle cx="120" cy="140" r="3" fill="#ddd6fe" opacity="0.6" />
    </svg>
  )
}

function NotFoundPage() {
  const history = useHistory()
  const { currentUser, isSignedIn } = useAuth()

  function handleGoHome() {
    history.push('/')
  }

  function handleGoToDashboard() {
    if (!isSignedIn || !currentUser) {
      history.push('/')
      return
    }

    const facilitiesUsers = currentUser && Array.isArray(currentUser.facilitiesUsers) ? currentUser.facilitiesUsers : []
    const coachFacilitiesUser = facilitiesUsers.find((user) => user.admin || user.coach)

    if (coachFacilitiesUser) {
      history.push(`/facilities/${coachFacilitiesUser.facility.id}/calendar`)
      return
    }

    const isParent = !!_get(currentUser, 'students.length')
    if (isParent) {
      history.push(`/guardians/${currentUser.id}/students`)
      return
    }

    history.push('/')
  }

  function handleContactSupport() {
    openCrispChat()
  }

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Leevo</title>
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-purple-100 flex items-center justify-center p-4">
        <div className="max-w-2xl w-full text-center">
          <div className="mb-8">
            <SkaterFallingIllustration />
          </div>

          <div className="mb-6">
            <h1 className="text-8xl md:text-9xl font-bold bg-gradient-to-r from-purple-600 to-purple-400 bg-clip-text text-transparent mb-4">
              404
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-3">Oops! You took a wrong turn</h2>
            <p className="text-lg text-gray-600 max-w-md mx-auto">
              Looks like this page decided to do a triple axel and disappeared. Let&apos;s get you back on track!
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={handleGoHome}
              variant="default"
              size="lg"
              className="bg-purple-600 hover:bg-purple-700 text-white"
            >
              Go Home
            </Button>
            {isSignedIn && (
              <Button
                onClick={handleGoToDashboard}
                variant="outline"
                size="lg"
                className="border-purple-600 text-purple-600 hover:bg-purple-50"
              >
                Go to Dashboard
              </Button>
            )}
            <Button
              onClick={handleContactSupport}
              variant="ghost"
              size="lg"
              className="text-purple-600 hover:bg-purple-100"
            >
              Contact Support
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default NotFoundPage
